import basicController from "servicestack/basic.controller.properties";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import ServiceBus from "servicestack/service-bus";
import RetrieveTokenInfo from "emun.order/retrieve-token-info";
import ChangeWritingRepPrompt from "emun.order/order-change-writingrep-prompt";
import ChangeSalesRepPrompt from "emun.order/order-change-salesrep-prompt";

export default class OrderDetailsHeaderController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.orderConfig = orderConfig;
		$ctrl.labels = labels;
		$ctrl.customerUrl = $ctrl.$appConfig.serviceUrl.replace(
			`service/`,
			`#/cust/${$ctrl.order.retailerId}`
		);
		$ctrl.bus
			.send("QueryRetailers.json?Id=" + $ctrl.order.retailerId)
			.then(function (res) {
				$ctrl.retailer = res.data.results[0];
			});
		$ctrl.bus
			.send("QueryRetailerShippingLocations.json?RetailerId=" + $ctrl.order.retailerId + "&Id=" + $ctrl.order.shippingLocationId)
			.then(function (res) {
				$ctrl.retailerLocation = res.data.results[0];
			});
	}
	retrieveTokenInfo(token, cvv) {
		let $ctrl = this;
		return RetrieveTokenInfo({ token: token, cvv: cvv });
	}
	changeWritingRep() {
		let $ctrl = this;
		return ChangeWritingRepPrompt.open({order: $ctrl.order}).then(function() {
			$ctrl.$cart.load();
		});
	}
	changeRep() {
		let $ctrl = this;
		return ChangeSalesRepPrompt.open({order: $ctrl.order}).then(function() {
			$ctrl.$cart.load();
		});
	}
}
